module.exports = __webpack_public_path__ + "static/sagehat-6e341141f73eab9186fc7719e8eac81d.jpeg";